
export default {
  statis_artisans: [],
  statis_interventions: []
}
